import { ref } from 'vue';
import { useTask } from '@/ui/concerns';
import { list as getInspectionList } from '@/services/api/resources/inspection';
import { InspectionQuery } from '@/services/api/resources/inspection/query';
import { sequence } from '@/ui/helpers';
import { InspectionStatus, Status } from '@/entities/todo';

export const useInspectionCheck = (statuses: Array<Status> = [], inspectionStatuses: Array<InspectionStatus> = []) => {
  const checkLoading = ref<boolean>(true);
  const checkResult = ref<boolean>();

  const checkQuery = (): InspectionQuery => ({
    page: 1,
    perPage: 1,
    sort: '',
    dir: '',
    timezone: '',
    search: '',
    assignee: [],
    doneBy: [],
    entityItem: [],
    categories: [],
    status: statuses,
    inspectionStatus: inspectionStatuses,
    doneAtStart: null,
    doneAtEnd: null,
    overdue: null,
    questionTitle: [],
    response: [],
    lazyPagination: 1,
  });

  const performCheck = useTask(
    () => sequence(
      getInspectionList(checkQuery()),
    ),
    ([
      listResponse,
    ]) => {
      checkResult.value = listResponse.data.length > 0;
      checkLoading.value = false;
    },
  );

  return {
    checkLoading,
    checkResult,
    performCheck,
  };
};
